import React from 'react';

export interface InputCheckBoxProp {
  name: string;
  text: string;
  checked?: boolean;
  onChecked: (it: any) => void;
  disabled?: boolean;
}

const InputCheckBox = ({
  name,
  text,
  checked,
  onChecked,
  disabled = false,
}: InputCheckBoxProp) => {
  return (
    <>
      <label
        style={{
          display: 'block',
          paddingLeft: '22px',
          textIndent: '-22px',
        }}
      >
        <input
          type="checkbox"
          name={name}
          style={{ verticalAlign: 'middle' }}
          onChange={onChecked}
          checked={checked}
          disabled={disabled}
        />
        <span style={{ verticalAlign: 'middle', marginLeft: '7px' }}>
          {text}
        </span>
      </label>
      <br />
    </>
  );
};

export default InputCheckBox;
